import { Image } from "./images";

export enum Pipeline {
  LUNGS_REPORT = "LUNGS_REPORT",
  NODULES = "NODULES",
  BATCH = "BATCH",
}

export interface Task {
  id: string;
  createdAt: string;
  name: string;
  sessionId: string;
  statuses: TaskStatus[];
  completed: boolean;
  description: string;
  pipeline: Pipeline;
  image: Image;
}

export interface TaskBatch {
  id: string;
  createdAt: string;
  name: string;
  description: string;
  lungsTasks: Task[];
  nodulesTasks: Task[];
  completed: boolean;
  completedTasksNumber: number;
  tasksNumber: number;
  hasFailedTask: boolean;
}

export enum PipelineSteps {
  SUBMITTED = "SUBMITTED",
  CONVERTED = "CONVERTED",
  SEGMENTED = "SEGMENTED",
  EXTRACTED = "EXTRACTED",
  RENDERED = "RENDERED",
}

export enum TaskStatusType {
  STARTED = "STARTED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  TERMINATED = "TERMINATED",
  WAITING = "WAITING",
  BETWEEN_STAGES = "BETWEEN_STAGES",
}

export interface TaskStatus {
  id: string;
  createdAt: string;
  status: TaskStatusType;
  message: string;
  worker: string;
  processingTime: number;
  stage: PipelineSteps;
  pipeline: Pipeline;
}

export const initialization_status: TaskStatus = {
  id: "0",
  createdAt: "0",
  status: TaskStatusType.WAITING,
  message: "Waiting for the task to start",
  worker: "None",
  processingTime: 0,
  stage: PipelineSteps.SUBMITTED,
  pipeline: Pipeline.LUNGS_REPORT,
};

export const emptyStatus: TaskStatus = {
  id: "",
  createdAt: "",
  status: TaskStatusType.WAITING,
  message: "",
  worker: "",
  processingTime: 0,
  stage: PipelineSteps.SUBMITTED,
  pipeline: Pipeline.LUNGS_REPORT,
};
